import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    url: 'https://auth.dev.protones.it/auth',
    realm: 'protones',
    clientId: 'rendi-ui'
});

export default keycloak;